module.exports = __webpack_public_path__ + "img/facebook.1cfde77b.svg";